import { useSDK } from '@metamask/sdk-react';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useLoadingState } from '../../hooks/useLoader';
import { useWallet } from '@solana/wallet-adapter-react';
import { AuthContext } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useController, useForm } from 'react-hook-form';
import Overlay from '../../ui/Overlay';
import Dropdown from '../../ui/Dropdown';

import Loader from '../../ui/Loader';
import { ArrowRight } from 'lucide-react';
import { toast } from 'sonner';
import { fetchChainDetails, getMetaMaskProvider } from '../../blockchainInteraction/finaliseGrading';
import mintedAnimation from '../../assets/greenpill/mintedAnimation.gif';
import {
    getMintPriceForEVM,
    getMintPriceForEVMInStableCoin,
    getMintPriceForSolana,
    getMintTransaction,
    getMintTransactionWithStableCoin,
    getSPLTokenBalance,
    getTokenBalance,
    getWhitelistedTokenAddresses,
    mintNFT,
    mintNftWithToken,
} from '../../apis/geenpills/mintNFT';
import { merkletree, MINTPRICE_USD, RPC_ENDPOINT_L } from '../../constants/apiPaths';
import { Connection, LAMPORTS_PER_SOL } from '@solana/web3.js';
import { BrowserProvider, formatEther } from 'ethers';
import { getChains, getTokens, getTokensForBudget } from '../../apis/general/general';
import walletimage from '../../assets/walletimage.png';
import greenpillmetamask from '../../assets/greenpill/greenpillmetamask.png';
import greenpillphantom from '../../assets/greenpill/greenpillphantom.png';
import yellowMetaIcon from '../../assets/greenpill/yellowMetaIcon.png';
import { useGlobalState } from '../../contexts/GlobalState';
import { useHome } from '../../contexts/HomeContext';
import ChangeWallet from './ChangeWallet';
import { updateWallet } from '../../apis/geenpills/updateWallet';
import GradientBorder from '../../ui/GradientBorder';
import { metaConnection, phantomConnection } from '../../helpers/greenPillHelper';
import Feedbackclose from '../../assets/icons/Feedbackclose';
import ButtonNew from '../../ui/ButtonNew';

const ethTokenList = [
    {
        _id: '00001',
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
        image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1748428174954.png',
        chainId: 10,
        chainImage:
            'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1730537606524.png',
        isUSDStableCoin: false,
        chainName: 'optimism',
    },
    {
        _id: '00002',
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
        image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1748428174954.png',
        chainId: 8453,
        chainImage:
            'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743617007174.jpg',
        isUSDStableCoin: false,
        chainName: 'base',
    },
    {
        _id: '00003',
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
        image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1748428174954.png',
        chainId: 42161,
        chainImage:
            'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743616326342.png',
        isUSDStableCoin: false,
        chainName: 'arbitrum',
    },
    {
        _id: '00004',
        name: 'Sol',
        symbol: 'SOL',
        decimals: 9,
        image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743616935585.jpg',

        chainImage:
            'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1743616935585.jpg',
        isUSDStableCoin: false,
        chainName: 'solana',
    },
    {
        _id: '00005',
        name: 'Celo',
        symbol: 'CELO',
        decimals: 18,
        chainId: 42220,
        image: 'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1744055426551.png',

        chainImage:
            'https://atlantis-staging-bucket.s3.ap-south-1.amazonaws.com/auxiliary/images/image1744055426551.png',
        isUSDStableCoin: false,
        chainName: 'celo',
    },
];

function MintNFTModal({ close, contractAddresses }) {
    const myRef = useRef({ close });
    const { dispatch } = useContext(AuthContext);
    const [linkingWalletModal, setLinkingWalletModal] = useState({
        from: '',
        type: '',
    });

    const { account } = useSDK();
    const { loading, startLoading, stopLoading } = useLoadingState();
    const { state: landscapesState } = useGlobalState();
    const wallet = useWallet();
    const { fetchData } = useHome();
    const [tokens, setTokens] = useState([]);
    const [whitelistedTokens, setWhitelistedTokens] = useState([]);
    const [chains, setChains] = useState([]);
    const [isMinted, setIsMinted] = useState(false);
    const { state } = useContext(AuthContext);
    const userProfile = state.user[0];

    // useAutoSelectPhantom(close)
    const {
        register,
        handleSubmit,
        control,
        getValues,
        trigger,
        formState: { errors },
        setError,
        reset,
        setValue,

        clearErrors,
    } = useForm({
        mode: 'onChange',
    });

    const { field: landscapeField } = useController({
        name: 'landscape',
        control,
        rules: { required: 'Please choose a landscape' },
    });

    const { field: chainField } = useController({
        name: 'chain',
        control,
        rules: {
            validate: (value) => {
                if (!landscapeField.value) return 'Please choose a landscape first';
                if (!value) return 'Please choose a chain';
                return true;
            },
        },
    });

    const { field: tokenField } = useController({
        name: 'token',
        control,
        rules: {
            validate: (value) => {
                if (!chainField.value) return 'Please choose a chain first';
                if (!value) return 'Please choose a token';
                return true;
            },
        },
    });

    const allowedChains = useMemo(() => {
        return landscapeField.value?.contractAddresses?.map((contract) => contract?.chainId) || [];
    }, [landscapeField.value]);
    useEffect(() => {
        async function fetchDataWrapper() {
            try {
                const [tokensRes, chainsRes] = await Promise.all([getTokensForBudget(), getChains()]);
                const chainPresents = chainsRes?.data?.filter((chain) => allowedChains.includes(chain?.chainId));

                setTokens([...tokensRes.filter((coin) => coin?.isUSDStableCoin), ...ethTokenList]);
                setChains(chainPresents);
            } catch (error) {
                console.log(error);
            }
        }
        fetchDataWrapper();
    }, [allowedChains]);

    useEffect(() => {
        async function fetchAllowedTokens() {
            // Example: fetch tokens for the selected chain
            if (chainField?.value?.chainId) {
                const response = await getWhitelistedTokenAddresses(
                    chainField.value.chainId,
                    landscapeField.value?.contractAddresses.find((c) => c.chainId === chainField?.value?.chainId)
                        ?.contractAddress
                );

                const arrayResponse = [...response]?.map((address) => address?.toLowerCase());

                setWhitelistedTokens(arrayResponse);
            } else {
            }
        }
        if (chainField?.value?.chainId) fetchAllowedTokens();
    }, [chainField?.value?.chainId, landscapeField.value?.contractAddresses]);
    const allowedTokens = useMemo(() => {
        return tokens?.filter((token) => {
            if (token?.isUSDStableCoin && token?.chainName?.toLowerCase() !== 'solana') {
                return (
                    token?.chainName === chainField?.value?.name &&
                    whitelistedTokens?.includes(token?.address?.toLowerCase())
                );
            } else {
                return token?.chainName === chainField?.value?.name;
            }
        });
    }, [tokens, chainField?.value?.name, whitelistedTokens]);
    // const allowedTokens = useMemo(() => {
    //     return tokens?.filter((token) => token?.chainName === chainField?.value?.name);
    // }, [tokens, chainField?.value?.name]);

    useEffect(() => {
        function handleClickOutside(e) {
            // Close the modal if the click is outside the modal content
            if (myRef.current && !myRef.current.contains(e.target)) {
                close();
            }
        }

        // Add the event listener to close modal on outside click
        document.addEventListener('mousedown', handleClickOutside, true);

        // Clean up the event listener when component unmounts
        return () => {
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
    }, [close]);

    const linkHandler = async (type) => {
        if (type === 'metamask') {
            const metaMaskProvider = getMetaMaskProvider();
            if (!metaMaskProvider) {
                const installUrl = 'https://metamask.io/download.html';
                toast.info('Opening MetaMask installation page in a new tab...');
                window.open(installUrl, '_blank'); // Open the URL in a new tab
                // toast.error('MetaMask is not installed or unavailable');
                return;
            }
            const accounts = await metaMaskProvider.request({
                method: 'eth_requestAccounts',
            });

            if (!accounts || accounts.length === 0) {
                toast.error('Failed to connect wallet');
                return;
            }

            const newWallet = accounts[0]?.toLowerCase();

            const response = await updateWallet(newWallet, undefined);
            if (response?.response?.data?.code === 400) {
                toast?.error(response?.response?.data?.message);
            }

            if (response?.evmAddress) {
                // toast?.success('Wallet changed successfully');
                dispatch({ type: 'changeWalletEVM', payload: newWallet });
                // or 'phantom' depending on type
            }
        }

        if (type === 'phantom') {
            try {
                const phantom = wallet.wallets.find((w) => w.adapter.name === 'Phantom');
                if (!phantom || !phantom.adapter) {
                    toast.error('Phantom wallet not found');
                    return;
                }

                if (phantom.adapter?.name !== 'Phantom') {
                    await wallet.select(phantom.adapter.name);
                }

                if (!phantom.adapter.connected) {
                    await phantom.adapter.connect();
                }

                const publicKey = phantom.adapter.publicKey;
                if (!publicKey) {
                    toast.error('Failed to get Phantom wallet address');
                    return;
                }

                const newWallet = publicKey.toBase58();

                const response = await updateWallet(undefined, newWallet);
                if (response?.response?.data?.code === 400) {
                    toast?.error(response?.response?.data?.message);
                    return;
                }

                if (response?.walletAddress) {
                    dispatch({ type: 'changeWalletSolana', payload: response?.walletAddress });
                }
            } catch (error) {
                console.error('Phantom Wallet Error:', error);
                toast.error('Error connecting to Phantom wallet');
            }
        }
    };
    const onSubmit = async (data) => {
        const { landscape } = data;
        const { contractAddresses } = landscape;
        const selectedContract = contractAddresses?.find(
            (contract) => contract.chainName?.toLowerCase() === data?.token?.chainName?.toLowerCase()
        );

        const { chainId, contractAddress, chainName } = selectedContract;

        if (chainName === 'solana') {
            const phantom = wallet.wallets.find((w) => w.adapter.name === 'Phantom');

            const phantomConnectionResponse = await phantomConnection(userProfile.walletAddress, wallet);

            if (phantomConnectionResponse === 'chainerror') {
                return;
            } else if (!phantomConnectionResponse) {
                handleChangeWalletAddress('mint', 'phantom');
                return;
            } else if (phantomConnectionResponse?.text === 'changewallet') {
                const response = await updateWallet(undefined, phantomConnectionResponse?.wallet);
                if (response?.response?.data?.code === 400) {
                    toast?.error(response?.response?.data?.message);
                }

                if (response?.walletAddress) {
                    // toast?.success('Wallet changed successfully');
                    dispatch({ type: 'changeWalletSolana', payload: phantomConnectionResponse.wallet });
                    // or 'phantom' depending on type
                }
            }

            // Continue with minting logic...
            const { stateURIsForSolana, name, solanaTreasuryWalletAddress } = landscape;
            const metadataUri = stateURIsForSolana[1];
            const collectionMintString = selectedContract?.collectionAddress;
            const publicKey = phantomConnectionResponse;

            try {
                const connection = new Connection(RPC_ENDPOINT_L, 'confirmed');

                startLoading();
                if (data?.token?.isUSDStableCoin) {
                    const tokenBalance = await getSPLTokenBalance(phantomConnectionResponse, data?.token?.address);

                    if (tokenBalance < MINTPRICE_USD) {
                        toast.error(
                            `Insufficient ${data?.token?.name}  : You need  ${MINTPRICE_USD} ${data?.token?.symbol}`
                        );
                        return;
                    }

                    const transaction = await getMintTransactionWithStableCoin(
                        metadataUri,
                        name,
                        collectionMintString,
                        solanaTreasuryWalletAddress,
                        connection,
                        phantom?.adapter,
                        data?.token?.address,
                        data?.token?.decimals
                    );

                    const signature = await phantom.adapter.sendTransaction(transaction, connection);

                    const confirmResult = await connection.confirmTransaction(signature, 'confirmed');

                    if (confirmResult?.value?.err !== null) {
                        toast.error(confirmResult?.value?.err);
                        return;
                    } else {
                        setTimeout(fetchData, 3000);
                        setIsMinted(true);
                        setTimeout(() => {
                            close();
                        }, 5000);
                    }
                } else {
                    const lamports = await connection.getBalance(phantom.adapter.publicKey);
                    const solBalance = lamports / LAMPORTS_PER_SOL;
                    const mintPrice = await getMintPriceForSolana();

                    if (solBalance < mintPrice) {
                        toast.error(`Insufficient SOL : You need at least ${mintPrice} SOL`);
                        return;
                    }

                    const transaction = await getMintTransaction(
                        metadataUri,
                        name,
                        collectionMintString,
                        solanaTreasuryWalletAddress,
                        connection,
                        phantom?.adapter
                    );

                    const signature = await phantom.adapter.sendTransaction(transaction, connection);
                    const confirmResult = await connection.confirmTransaction(signature, 'confirmed');

                    if (confirmResult?.value?.err !== null) {
                        toast.error(confirmResult?.value?.err);
                        return;
                    } else {
                        setTimeout(fetchData, 3000);
                        setIsMinted(true);
                        setTimeout(() => {
                            close();
                        }, 5000);
                    }
                }
            } catch (error) {
                console.log(error, 'see the error');
            } finally {
                stopLoading();
            }

            return;
        } else {
            startLoading();
            const metaMaskProvider = getMetaMaskProvider();
            try {
                const metaConnectionResponse = await metaConnection(userProfile.evmAddress, chainId);

                if (metaConnectionResponse === 'chainerror') {
                    return;
                } else if (!metaConnectionResponse) {
                    handleChangeWalletAddress('mint', 'metamask');
                    return;
                } else if (metaConnectionResponse?.text === 'changewallet') {
                    const response = await updateWallet(metaConnectionResponse?.wallet, undefined);
                    if (response?.response?.data?.code === 400) {
                        toast?.error(response?.response?.data?.message);
                    }

                    if (response?.evmAddress) {
                        // toast?.success('Wallet changed successfully');
                        dispatch({ type: 'changeWalletEVM', payload: metaConnectionResponse?.wallet });
                        // or 'phantom' depending on type
                    }
                }

                if (data?.token?.isUSDStableCoin) {
                    const requiredTokenAmount = await getMintPriceForEVMInStableCoin(
                        contractAddress,
                        chainId,
                        data?.token?.address
                    );

                    const tokenBalance = await getTokenBalance(chainId, data?.token?.address, metaConnectionResponse);

                    if (tokenBalance < requiredTokenAmount) {
                        toast.error(
                            `Insufficient ${data?.token?.name}  : You need  ${Number(
                                Number(requiredTokenAmount) / 10 ** data?.token?.decimals
                            )?.toFixed(2)} ${data?.token?.symbol}`
                        );

                        stopLoading();
                        return;
                    }

                    const { success, code, result } = await mintNftWithToken(
                        data?.token?.address,
                        contractAddress,
                        chainId
                    );

                    if (!success) {
                        // toast.error(`May be winner has not linked metamask wallet in his "Impact Miner" account`);

                        stopLoading();
                        toast.error(code);
                        return;
                    }

                    if (success) {
                        // integrate api to register funding

                        setTimeout(() => {
                            fetchData();
                        }, 3000);

                        setIsMinted(true);
                        setTimeout(() => {
                            close();
                        }, 5000);
                    }
                } else {
                    const provider = new BrowserProvider(metaMaskProvider);
                    console?.log('see balance');
                    const signer = await provider.getSigner();
                    const address = await signer.getAddress();
                    const balance = await provider.getBalance(address);
                    const balanceEth = parseFloat(formatEther(balance));

                    const requiredEth = await getMintPriceForEVM(contractAddress, chainId);

                    if (balanceEth < requiredEth) {
                        toast.error(
                            `Insufficient ${chainId === 42220 ? 'CELO' : 'ETH'} : You need at least ${requiredEth}${chainId === 42220 ? ' CELO' : ' ETH'
                            }`
                        );
                        stopLoading();
                        return;
                    }

                    const { success, code, result } = await mintNFT(contractAddress, chainId);

                    if (!success) {
                        // toast.error(`May be winner has not linked metamask wallet in his "Impact Miner" account`);
                        stopLoading();
                        toast.error(code);
                        return;
                    }
                    if (success) {
                        // integrate api to register funding

                        setTimeout(() => {
                            fetchData();
                        }, 3000);

                        setIsMinted(true);
                        setTimeout(() => {
                            close();
                        }, 5000);
                    }
                }
            } catch (error) {
            } finally {
                stopLoading();
            }
        }
    };
    const handleChangeWalletAddress = async (from, type) => {
        setLinkingWalletModal({
            from,
            type,
        });
    };
    const { landscapes } = landscapesState;
    const phantomWallet = wallet.wallets.find((w) => w.adapter.name === 'Phantom');
    const publicKey = phantomWallet.adapter.publicKey;

    return (
        <Overlay>
            <div
                className={`absolute rounded-lg left-[50%] p-6 w-[90%] ${isMinted ? ' bg-grayBgNormal backdrop-blur-3xl' : 'bg-grayBgNormal '
                    }  md:w-[40%]   border border-borderUnderline   translate-x-[-50%] translate-y-[-50%] top-[50%]`}
            >
                <div ref={myRef} className="relative w-full h-full">
                    {!linkingWalletModal?.from && (

                        <ButtonNew
                            onClick={() => {
                                close();
                            }}
                            variant="closeNeutral"
                            size="xs"
                            shape="oval"
                            className="absolute z-[9999] top-0 right-0 !p-0"
                            fixedMinWidth
                            minWidthClass="min-w-[2.5rem]"
                        >
                            <Feedbackclose />
                        </ButtonNew>

                    )}

                    {linkingWalletModal?.from ? (
                        <div>
                            {linkingWalletModal?.type === 'metamask' && (
                                <div>
                                    <ChangeWallet
                                        close={close}
                                        handleChangeWalletAddress={handleChangeWalletAddress}
                                        type={linkingWalletModal?.type}
                                        linkedWallet={userProfile?.evmAddress}
                                        from={linkingWalletModal?.from}
                                    />
                                </div>
                            )}
                            {linkingWalletModal?.type === 'phantom' && (
                                <div>
                                    <ChangeWallet
                                        close={close}
                                        handleChangeWalletAddress={handleChangeWalletAddress}
                                        type={linkingWalletModal?.type}
                                        linkedWallet={userProfile?.walletAddress}
                                        from={linkingWalletModal?.from}
                                    />
                                </div>
                            )}
                        </div>
                    ) : isMinted ? (
                        <div className="flex flex-col relative items-center    justify-center">
                            <div className="relative w-full h-[32.3125rem] ">
                                {/* Background layer with opacity */}
                                <div className="absolute inset-0 bg-nft-gradient opacity-15 pointer-events-none z-0"></div>

                                {/* Content layer */}
                                <div className="absolute top-[50%] w-full left-[50%]  translate-x-[-50%] translate-y-[-50%] z-10 text-center">
                                    <div className="relative w-full">
                                        <div className="flex flex-col items-center">
                                            <p className="text-3xl text-tPrimary absolute w-full top-0 left-[50%] translate-x-[-50%] md:text-5xl   font-semibold">
                                                New NFT Minted
                                            </p>
                                            <img
                                                className="w-[23.375rem]"
                                                src={mintedAnimation}
                                                alt="minted-animation"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="flex flex-col  border-b border-borderUnderline pb-4 ">
                                <p className="text-textPrimary text-2xl font-bold">Mint Now</p>
                                <p className="text-textSecondary text-sm ">
                                    A $5 as mint price will be required to mint a new NFT
                                </p>
                            </div>
                            <div className="mt-4">
                                <form action="" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="flex flex-col items-center w-full gap-5 mt-4 ">
                                        <div className="w-full">
                                            <p className="text-textSecondary font-semibold mb-1">
                                                {userProfile?.evmAddress || userProfile?.walletAddress
                                                    ? 'Wallets linked to Profile'
                                                    : 'No Wallet linked to Profile'}
                                            </p>

                                            <div className={`flex flex-col gap-1`}>
                                                {userProfile?.evmAddress ? (
                                                    <div className="flex gap-2   ">
                                                        <img
                                                            className="w-7 h-7 object-cover rounded-full"
                                                            src={greenpillmetamask}
                                                            alt=""
                                                        />
                                                        <div>
                                                            <p className={`    `}>
                                                                <span className=" font-semibold">Linked Wallet:</span>
                                                                <span>
                                                                    {userProfile?.evmAddress.slice(0, 4)}...
                                                                    {userProfile?.evmAddress.slice(-4)}
                                                                </span>
                                                                <span
                                                                    onClick={() =>
                                                                        handleChangeWalletAddress('change', 'metamask')
                                                                    }
                                                                    className="text-[#0085FF] cursor-pointer ml-2 underline font-bold"
                                                                >
                                                                    change
                                                                </span>{' '}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <button
                                                        onClick={() => linkHandler('metamask')}
                                                        type="button"
                                                        className={` px-4 py-2 flex items-center gap-2 w-[12.5rem] rounded-md text-white  bg-metamask-gradient `}
                                                    >
                                                        <img
                                                            className="w-7 h-7 object-cover rounded-full"
                                                            src={yellowMetaIcon}
                                                            alt="metamask"
                                                        />
                                                        <span>
                                                            Link <span className="font-semibold">Metamask</span>{' '}
                                                        </span>
                                                    </button>
                                                )}
                                                {userProfile?.walletAddress ? (
                                                    <div className="flex gap-2 w-full   ">
                                                        <img
                                                            className="w-7 h-7 object-cover rounded-full"
                                                            src={greenpillphantom}
                                                            alt=""
                                                        />
                                                        <div>
                                                            <p className={`    `}>
                                                                <span className=" font-semibold">Linked Wallet:</span>
                                                                <span>
                                                                    {userProfile?.walletAddress.slice(0, 4)}...
                                                                    {userProfile?.walletAddress.slice(-4)}
                                                                </span>
                                                                <span
                                                                    onClick={() =>
                                                                        handleChangeWalletAddress('change', 'phantom')
                                                                    }
                                                                    className="text-[#0085FF] cursor-pointer ml-2 underline font-bold"
                                                                >
                                                                    change
                                                                </span>{' '}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <button
                                                        onClick={() => linkHandler('phantom')}
                                                        type="button"
                                                        className={` px-4 py-2 flex items-center gap-2 rounded-md  w-[12.5rem] text-white bg-phantom-gradient  `}
                                                    >
                                                        <img
                                                            className="w-7 h-7 object-cover rounded-full"
                                                            src={greenpillphantom}
                                                            alt="metamask"
                                                        />
                                                        <span>
                                                            Link <span className="font-semibold">Phantom</span>{' '}
                                                        </span>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                        <div className="w-full">
                                            <div className="w-full">
                                                <p className="text-textSecondary font-semibold">Choose Landscape</p>
                                                <div className="relative w-full ">
                                                    <Dropdown
                                                        data1Heading={
                                                            <div className="sticky top-0  bg-primaryBg z-10 ">
                                                                <p className="text-textPrimary">
                                                                    Progress in Landscapes:
                                                                </p>
                                                                <p className="text-textSecondary text-sm">
                                                                    Each landscape can only accommodate 400 fully
                                                                    transformed green pills. Ex, 50% means 200/400 slots
                                                                    for green pills have been filled
                                                                </p>
                                                            </div>
                                                        }
                                                        modifyLabel={(listItem) => {
                                                            return (
                                                                <span className="flex items-center text-tSecondary gap-5">
                                                                    <span>{listItem?.name} </span>
                                                                </span>
                                                            );
                                                        }}
                                                        data={landscapes}
                                                        selected={landscapeField.value}
                                                        onSelected={(selected) => {
                                                            landscapeField.onChange(selected);
                                                            setValue('chain', null);
                                                            setValue('token', null);
                                                            clearErrors(['chain', 'token']);
                                                        }}
                                                        modifySelected={(selected) => {
                                                            return (
                                                                <div className="flex items-center gap-5">
                                                                    <span className="text-tSecondary">
                                                                        {selected.name}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }}
                                                        noSelectedText="Choose Landscape"
                                                        btnClass=""
                                                        w="w-full"
                                                    />
                                                </div>
                                            </div>
                                            <p className="text-textSecondary text-sm font-semibold">
                                                {errors?.landscape && errors?.landscape?.message}
                                            </p>
                                        </div>

                                        <div className="flex items-center w-full gap-6 mt-5 ">
                                            <div className="w-full">
                                                <p className="text-textSecondary font-semibold">Chain to Mint on</p>
                                                <div className="relative w-full ">
                                                    <Dropdown
                                                        disabled={!landscapeField.value}
                                                        modifyLabel={(listItem) => {
                                                            return (
                                                                <span className="flex items-center text-tSecondary gap-5">
                                                                    <img
                                                                        className="w-5 h-5 rounded-full "
                                                                        src={listItem?.image}
                                                                        alt=""
                                                                    />
                                                                    {/* chainImage */}
                                                                    <span>{listItem?.name} </span>
                                                                </span>
                                                            );
                                                        }}
                                                        data={chains}
                                                        selected={chainField.value}
                                                        onSelected={(selected) => {
                                                            chainField.onChange(selected);
                                                            setValue('token', null);
                                                            clearErrors('token');
                                                        }}
                                                        modifySelected={(selected) => {
                                                            return (
                                                                <div className="flex items-center gap-5">
                                                                    <div className="relative">
                                                                        <img
                                                                            className="w-5 h-5 rounded-full "
                                                                            src={selected?.image}
                                                                            alt=""
                                                                        />
                                                                    </div>

                                                                    <span className="text-tSecondary">
                                                                        {selected.name}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }}
                                                        noSelectedText="Choose Chain"
                                                        btnClass={`${!landscapeField.value ? 'cursor-not-allowed' : ''
                                                            }`}
                                                        w="w-full"
                                                    />
                                                </div>
                                            </div>
                                            <div className="w-full">
                                                <p className="text-textPrimary font-semibold">Token</p>

                                                <div className="flex items-center">
                                                    <div className="relative w-full ">
                                                        <Dropdown
                                                            disabled={!chainField.value}
                                                            modifyLabel={(listItem) => {
                                                                return (
                                                                    <div className="flex items-center text-tSecondary gap-5">
                                                                        <div className="relative">
                                                                            <img
                                                                                className="w-5 h-5 rounded-full "
                                                                                src={listItem?.image}
                                                                                alt=""
                                                                            />

                                                                            <img
                                                                                className="w-3 h-3 absolute -top-1 -right-1 object-cover rounded-full "
                                                                                src={listItem?.chainImage}
                                                                                alt=""
                                                                            />
                                                                        </div>

                                                                        <span>{listItem?.symbol} </span>
                                                                    </div>
                                                                );
                                                            }}
                                                            data={allowedTokens}
                                                            isSymbol={true}
                                                            selected={tokenField.value}
                                                            onSelected={(selected) => tokenField.onChange(selected)}
                                                            noSelectedText="Choose Token"
                                                            btnClass={`${!chainField.value ? 'cursor-not-allowed' : ''
                                                                }`}
                                                            w="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <p className="text-textSecondary text-sm font-semibold">
                                                {Object.keys(errors)?.length === 2
                                                    ? 'Please choose a token and enter an amount'
                                                    : errors?.token?.message || errors?.totalRewardAmount?.message}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="mt-5 flex items-center justify-end">
                                        <button className=" bg-[#426A61] flex items-center py-3 px-4 justify-center gap-1 text-white border w-[11rem] border-[#699F84] rounded-lg ">
                                            {loading ? (
                                                <Loader color="fill-[#326F58]" />
                                            ) : (
                                                <>
                                                    <span>Mint Now</span> <ArrowRight size={14} />
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Overlay>
    );
}

export default MintNFTModal;
